const LOGO_URL = "https://customer-assets.emergentagent.com/job_0f63188c-f9dd-4eab-a2e3-7399e9175461/artifacts/oetdot0e_SalesAssets%20Logo.png";

const Footer = () => {
  return (
    <footer className="bg-[#0a2540] text-white py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="SalesAssets" 
                className="h-10 w-10 rounded-lg object-cover"
              />
              <span className="font-bold text-lg">SalesAssets</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Turn your completed jobs into professional sales assets. 
              Generate enquiries without the marketing hassle.
            </p>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">
              Support
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@salesassets.co" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Contact
                </a>
              </li>
              <li>
                <span className="text-slate-400 text-sm">£9/month</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 text-center text-slate-500 text-sm">
          © {new Date().getFullYear()} SalesAssets. Built for local service businesses.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
